import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

const API = process.env.REACT_APP_BACKEND_URL;
const CONSENT = 'home_smart_qr_statistics_choice';
const PREFIX = 'home_smart_qr_browser_';
const visits = new Map(); // Memory only: one opening per page load, including expiry redirects/retries.
const preference = () => { try { return window.localStorage.getItem(CONSENT) || 'unset'; } catch { return 'unset'; } };
const visitorId = code => {
  try {
    const key = PREFIX + code;
    const old = JSON.parse(window.localStorage.getItem(key) || 'null');
    if (old?.id && old.expires > Date.now()) return old.id;
    const item = { id: crypto.randomUUID(), expires: Date.now() + 180 * 86400000 };
    window.localStorage.setItem(key, JSON.stringify(item));
    return item.id;
  } catch { return null; }
};

export const HomeSmartEventAnalytics = ({ code }) => {
  const [choice, setChoice] = useState(preference), [settings, setSettings] = useState(() => preference() === 'unset');
  useEffect(() => {
    if (!code) return;
    if (!visits.has(code)) visits.set(code, crypto.randomUUID());
    const send = () => {
      if (document.visibilityState !== 'visible') return;
      const allowed = choice === 'granted' && preference() === 'granted';
      axios.post(`${API}/api/home-smart/events/${encodeURIComponent(code)}/visits`, {
        visit_id: visits.get(code), statistics_consent: allowed,
        visitor_id: allowed ? visitorId(code) : null,
      }).catch(() => {}); // Optional measurements must never block the offer or registration.
    };
    send(); document.addEventListener('visibilitychange', send);
    return () => document.removeEventListener('visibilitychange', send);
  }, [code, choice]);
  useEffect(() => {
    const sync = event => { if (event.key === CONSENT || event.key === null) { setChoice(preference()); setSettings(preference() === 'unset'); } };
    window.addEventListener('storage', sync);
    return () => window.removeEventListener('storage', sync);
  }, []);
  function choose(value) {
    try {
      window.localStorage.setItem(CONSENT, value);
      if (value === 'denied') Object.keys(window.localStorage).filter(k => k.startsWith(PREFIX)).forEach(k => window.localStorage.removeItem(k));
    } catch { /* No identifier is used if browser storage is unavailable. */ }
    setChoice(value); setSettings(false);
  }
  return <section className="border-b bg-white px-5 py-4 text-[#08234c]" data-testid="event-statistics-consent">
    <div className="mx-auto max-w-5xl flex flex-wrap items-center justify-between gap-4">
      {settings ? <><div className="min-w-0 flex-1 basis-64"><p className="font-semibold text-sm">Statistiche QR facoltative</p><p className="text-xs leading-5 mt-1" data-testid="event-statistics-explanation">Con il tuo consenso, un identificativo distinto per evento ci aiuta a stimare i browser visitatori. Puoi rifiutare e usare comunque la prova gratuita. Le aperture totali sono conteggiate senza questo identificativo. <Link to="/home-smart/privacy" target="_blank" rel="noreferrer" className="underline" data-testid="event-statistics-privacy">Privacy</Link></p></div><div className="flex flex-wrap gap-2"><Button variant="outline" size="sm" data-testid="event-statistics-decline" onClick={() => choose('denied')}>Rifiuta statistiche facoltative</Button><Button size="sm" data-testid="event-statistics-accept" onClick={() => choose('granted')}>Consenti statistiche</Button></div></>
        : <><p data-testid="event-statistics-current-choice" className="text-xs">Statistiche facoltative {choice === 'granted' ? 'consentite' : 'rifiutate'}</p><button type="button" className="text-xs underline" data-testid="event-statistics-preferences" onClick={() => setSettings(true)}>Modifica preferenze</button></>}
    </div>
  </section>;
};